import operatorOptions from './operator-options'
import _ from 'lodash'
import dropdown from 'scoreboard/components/dropdown'

/**
 * Renders a dropdown for selecting an operator based on the data type of the
 * underlying field (see #52694)
 * @param {JQuery} el the element to render the dropdown into
 * @param {String} parentDomainType the DomainType of the parent
 * object this filter is associated with. For example, if this is for
 * a chart serie, parentDomainType would be 'chart'.
 * @param {Object} filter the filter to render the dropdown for
 * @param {Object} underlyingField the field that the filter is based on
 * @param {Boolean} [allowEqualsEquation=true] whether to allow the "equals
 * equation" operator
 * @param {Boolean} [ellipsis=true] whether to include an
 * ellipsis after the operator name. This is used to indicate that there are
 * multiple steps when using filters in a wizard. Filters sometimes aren't in
 * a wizard though so there shouldn't be an ellipsis (#52910)
 */
function renderStrongOperatorDropdown({ el, parentDomainType, filter,
		underlyingField, allowEqualsEquation = true,
		ellipsis = true }) {
	let opOptions = operatorOptions(underlyingField, {
		parentDomainType,
		filter
	})
	if (!allowEqualsEquation) {
		opOptions = _.cloneDeep(opOptions)
		delete opOptions['equals-equation']
	}

	let previousOperator = el.val()
	let validOperators = _.keys(opOptions)

	let newOperator
	if (_.includes(validOperators, previousOperator)) {
		// if an operator was already selected and it's still valid, keep using that
		newOperator = previousOperator
	} else if (_.includes(validOperators, filter.operator)) {
		// if an operator wasn't selected yet (ie first rendering) and the filter
		// already had an operator defined, use that
		newOperator = filter.operator
	} else {
		// otherwise, just pick the first operator available
		newOperator = validOperators[0]
	}

	dropdown.object(el.empty(), opOptions, newOperator)
}

export default renderStrongOperatorDropdown

renderStrongOperatorDropdown.__filename__ = 'datasets/filters/render-strong-operator-dropdown.js'
